import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Toast } from 'react-bootstrap'
import { API, username } from '../API';
import Api from '../Api/Api';
import { isAutheticated } from "./auth/authhelper";
import { useAppContext } from '../Context/AppContext';
import "./Toast.css"

function ToastProduct({ product, handleClose, pauseVid, handleShowPopUp, VideoAllContent, sourceUrl }) {
  const { addToCart } = useAppContext();
  const { token } = isAutheticated()
  const [currentProduct, setCurrentProduct] = useState(false)
  // const [currentTimeout, setCurrentTimeout] = useState(false)
  // console.log("ffffffff", sourceUrl)
  // console.log("VideoContent", VideoAllContent)
  // // console.log("ffffffff", sourceUrl)




  // useEffect(() => {
  //   let timeout = setTimeout(function () { handleClose(); }, parseInt(`${product.duration}000`))
  //   return (() => {
  //     clearTimeout(timeout)
  //   })
  // })




  //
  // const trackProductClick = async () => {
  //   try {
  //     const isSubChannel = VideoAllContent?.channelType === "Subchannels";

  //     const networkChannel = isSubChannel
  //       ? VideoAllContent?.channel?.parentChannel &&
  //         VideoAllContent.channel.parentChannel._id
  //         ? VideoAllContent.channel.parentChannel._id
  //         : null
  //       : VideoAllContent?.channel?._id || null;

  //     const subchannelChannel = isSubChannel
  //       ? VideoAllContent?.channel?._id || null
  //       : null;

  //     await axios.post(
  //       `${API}/api/analytics/Product_click`,
  //       {
  //         productId:
  //           product?.type === "external"
  //             ? product?.productId
  //             : product?.product?._id,

  //         videoID: VideoAllContent?.videoId || VideoAllContent?.lessonId || VideoAllContent?._id,

  //         networkChannel,
  //         subchannelChannel,

  //         channelType: isSubChannel ? "subChannel" : "networkChannel",

  //         productName:
  //           product?.type === "external"
  //             ? product?.extProduct_Name
  //             : product?.product?.title,

  //         ProductThumbnail_Url:
  //           product?.type === "external"
  //             ? product?.ProductThumbnail_Url
  //             : product?.product?.url,
  //         price:
  //           product?.type === "external"
  //             ? product?.extProduct_Price
  //             : product?.product?.sale_price,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Click tracking failed", error);
  //   }
  // };
  // const trackProductClick = async () => {
  //   try {
  //     const rawType = VideoAllContent?.channelType; // "Subchannels", "networkChannel", or "SoComAdvisor"

  //     const isSubChannel = rawType === "Subchannels";
  //     const netchannel = rawType === "networkChannel";

  //     const isAdvisor = rawType === "SoComAdvisor";

  //     // 🔹 ID Mapping Logic
  //     // If it's an advisor, we set the advisor ID specifically
  //     const soComAdvisorId = isAdvisor ? VideoAllContent?.channel?._id : netchannel ? channel?.SoComAdvisor?.advisorId?._id : isSubChannel ? channel?.parentChannel?.SoComAdvisor?.advisorId?._id : null;

  //     // If it's a subchannel, get the parent. Otherwise, if it's not an advisor, it's a network channel.
  //     const networkChannelId = isSubChannel
  //       ? VideoAllContent?.channel?.parentChannel?._id || null
  //       : isAdvisor ? null : (VideoAllContent?.channel?._id || null);

  //     const subchannelChannelId = isSubChannel
  //       ? VideoAllContent?.channel?._id || null
  //       : null;

  //     // 🔹 Determine Enum Value for Backend
  //     let finalChannelType = "networkChannel";
  //     if (isSubChannel) finalChannelType = "subChannel";
  //     if (isAdvisor) finalChannelType = "SoComAdvisor";

  //     const payload = {
  //       productId: product?.type === "external" ? product?.productId : product?.product?._id,
  //       videoID: VideoAllContent?.videoId || VideoAllContent?.lessonId || VideoAllContent?._id,

  //       // Sending explicit IDs based on the type
  //       SoComAdvisor: soComAdvisorId,
  //       networkChannel: networkChannelId,
  //       subchannelChannel: subchannelChannelId,
  //       frontend_website_Video_Url: sourceUrl,
  //       channelType: finalChannelType,
  //       Product_Description: product?.extProduct_Description,
  //       Product_show_Button_Name: product?.show_Button_Name,
  //       external_ProductUrl: product?.externalProductUrl,
  //       productName: product?.type === "external" ? product?.extProduct_Name : product?.product?.title,
  //       ProductThumbnail_Url: product?.type === "external" ? product?.ProductThumbnail_Url : product?.product?.url,
  //       price: product?.type === "external" ? product?.extProduct_Price : product?.product?.sale_price,
  //     };

  //     await axios.post(
  //       `${API}/api/analytics/Product_click`,
  //       payload,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Click tracking failed", error);
  //   }
  // };



  const trackProductClick = async () => {
    try {
      const rawType = VideoAllContent?.channelType;
      const channelData = VideoAllContent?.channel;

      const isSubChannel = rawType === "Subchannels";
      const isNetworkChannel = rawType === "Channels";
      const isAdvisor = rawType === "SoComAdvisor";

      // 1. SoComAdvisor Logic (Always look for the top-most owner)
      // - If Advisor video: It's the channel itself.
      // - If Network video: It's in the channel's SoComAdvisor object.
      // - If Subchannel video: It's in the parentChannel's SoComAdvisor object.
      const soComAdvisorId = isAdvisor
        ? channelData?._id
        : isNetworkChannel
          ? channelData?.SoComAdvisor?.advisorId?._id || channelData?.SoComAdvisor?.advisorId // handles both populated and ID
          : isSubChannel
            ? channelData?.parentChannel?.SoComAdvisor?.advisorId?._id || channelData?.parentChannel?.SoComAdvisor?.advisorId
            : null;

      // 2. Network Channel Logic
      // - If Subchannel: It's the parent.
      // - If Network: It's the channel itself.
      const networkChannelId = isSubChannel
        ? channelData?.parentChannel?._id
        : isNetworkChannel
          ? channelData?._id
          : null;

      // 3. Subchannel Logic
      // - Only set if the raw type is specifically a Subchannel.
      const subchannelChannelId = isSubChannel ? channelData?._id : null;

      // Determine Enum for Backend
      let finalChannelType = "networkChannel";
      if (isSubChannel) finalChannelType = "subChannel";
      if (isAdvisor) finalChannelType = "SoComAdvisor";

      const payload = {
        productId: product?.type === "external" ? product?.productId : product?.product?._id,
        videoID: VideoAllContent?.videoId || VideoAllContent?.lessonId || VideoAllContent?._id,

        // Explicitly providing the hierarchy
        SoComAdvisor: soComAdvisorId,
        networkChannel: networkChannelId,
        subchannelChannel: subchannelChannelId,

        channelType: finalChannelType,
        frontend_website_Video_Url: sourceUrl,
        productName: product?.type === "external" ? product?.extProduct_Name : product?.product?.title,
        ProductThumbnail_Url: product?.type === "external" ? product?.ProductThumbnail_Url : product?.product?.url,
        price: product?.type === "external" ? product?.extProduct_Price : product?.product?.sale_price,
        extProductCurrencySymbole: product?.extProductCurrencySymbole || "",
        extProductCurrencyCode: product?.extProductCurrencyCode || "",
        extProductCurrencyCountryName: product?.extProductCurrencyCountryName || "",
        Product_Description: product?.extProduct_Description,
        Product_show_Button_Name: product?.show_Button_Name,
        external_ProductUrl: product?.externalProductUrl,
      };

      await axios.post(`${API}/api/analytics/Product_click`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error("Click tracking failed", error);
    }
  };






  //click functionality 

  // console.log("productviein the fiest way w", product)
  console.log("VideoAllContent the fiest way w", VideoAllContent)



  useEffect(() => {
    let popupTimeout; // To manage the timeout
    let alternateInterval; // To manage the alternating interval
    let isPopupVisible = false; // Track popup visibility

    const showPopup = () => {
      handleShowPopUp(); // Show the popup
      isPopupVisible = true;
    };

    const hidePopup = () => {
      handleClose(); // Hide the popup
      isPopupVisible = false;
    };

    const togglePopup = () => {
      if (isPopupVisible) {
        hidePopup(); // Hide if currently visible
      } else {
        showPopup(); // Show if currently hidden
      }
    };

    if (product?.duration === "throughout") {
      // Clear any existing interval to prevent multiple timers
      clearInterval(alternateInterval);

      // Show popup after 5 seconds initially
      popupTimeout = setTimeout(() => {
        showPopup(); // Initial show after 5 seconds

        // Alternate between show (30 seconds) and hide (5 seconds)
        alternateInterval = setInterval(() => {
          togglePopup();
        }, isPopupVisible ? 30000 : 5000); // Show for 30s, hide for 5s
      }, 5000);
    } else if (product?.duration) {
      // Show popup for the specified duration (in seconds)
      const durationInMs = parseInt(`${product.duration}000`, 10); // Convert to milliseconds
      showPopup(); // Show the popup
      popupTimeout = setTimeout(() => {
        hidePopup(); // Close the popup after the specified duration
      }, durationInMs);
    }

    // Cleanup on component unmount or dependency changes
    return () => {
      clearTimeout(popupTimeout); // Clear any timeout
      clearInterval(alternateInterval); // Clear any interval
    };
  }, [product?.duration, handleClose, handleShowPopUp]);










  // console.log("product", product)

  // const enterMouse =  () => {
  //   console.log("enter");
  //   clearTimeout(timeout)
  // }
  // const leaveMouse = () => {
  //   console.log("leave");
  //   timeout = setTimeout(function () { handleClose(); }, parseInt(`${product.duration}000`))
  // }


  // const buttonClick = async () => {
  //   // window.open(product?.url);
  //   pauseVid()
  //   // addToCart()
  //   addToCart(product)
  //   const { data } = await Api.postOrder(username, product.product?._id, product.CTA);
  //   console.log(data);
  // }
  const buttonClick = async () => {
    try {
      pauseVid(); // Ensure this function is defined

      addToCart(product); // Add product to cart

      // Ensure `username` is available
      if (!username || !product?.product?._id || !product.CTA) {
        console.error("Missing required data for order.");
        return;
      }

      // Place order
      const { data } = await Api.postOrder(username, product.product?._id, product.CTA);
      console.log("Order response:", data);

    } catch (error) {
      console.error("Error in buttonClick:", error);
    }
  };


  console.log(product)


  return (

    <Toast
      style={{
        position: "fixed",
        bottom: "3rem",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        width: "90%",
        maxWidth: "1000px",
        // padding: "0.5rem 1rem",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        // borderRadius: "12px",
        backgroundColor: "#fff",
      }}
      className="landscape-toast"
    >
      <Toast.Header className="p-2" closeButton={false}>
        <div className="d-flex align-items-center w-100 gap-3 flex-wrap flex-md-nowrap">

          {/* Image */}
          <div style={{ width: "70px", flexShrink: 0 }}>
            <img
              className="img-fluid rounded shadow"
              src={
                product?.type === "external"
                  ? product?.ProductThumbnail_Url
                  : product?.product?.image || product?.url
              }
              alt="Product Thumbnail"
              style={{
                height: "55px",
                width: "100%",
                objectFit: "cover",
                cursor: product?.type === "external" ? "pointer" : "default",
              }}
              onClick={() => {
                if (product?.type === "external" && product?.externalProductUrl) {
                  pauseVid();
                  window.open(product?.externalProductUrl, "_blank");
                }
              }}
            />
          </div>

          {/* Content */}
          <div style={{ flexGrow: 1, minWidth: 0 }}>
            <h6 className="fw-bold mb-1 text-truncate" style={{ fontSize: "0.95rem" }}>
              {`${product?.type === "external"
                ? product?.extProduct_Name
                : product?.product?.title}${'               ' /* 10 spaces using &nbsp; */}
${product?.type === "external"
                  ? `${product?.extProductCurrencySymbole || ""}${product?.extProduct_Price || ""}`
                  : product?.product?.sale_price
                }`}
            </h6>
            {/* <p className="mb-1 fw-semibold text-dark" style={{ fontSize: "0.85rem" }}>
              {product?.type === "external"
                ? `${product?.extProduct_Price}`
                : `${product?.product?.sale_price}`}
            </p> */}
            <p
              className="text-muted mb-0"
              style={{
                fontSize: "0.75rem",
                // display: "-webkit-box",
                // WebkitLineClamp: 1,
                // WebkitBoxOrient: "vertical",
                // overflow: "hidden",
              }}
            >
              {(product?.type === "external"
                ? product?.extProduct_Description
                : product?.product?.description
              )?.slice(0, 175)}
            </p>
          </div>

          {/* Button */}
          <div style={{ flexShrink: 0 }}>
            {product?.type === "external" && product?.externalProductUrl && (
              <button
                onClick={() => {
                  pauseVid();
                  trackProductClick(); // 🔥 TRACK CLICK
                  window.open(product.externalProductUrl, "_blank");
                }}
                className="btn btn-warning"
                style={{
                  fontSize: "0.8rem",
                  padding: "6px 10px",
                  height: "40px",
                  lineHeight: "1",
                  whiteSpace: "nowrap",
                }}
              >
                <i className="bi bi-box-arrow-up-right me-1"></i>
                {product?.show_Button_Name || "Visit"}
              </button>
            )}
            {product?.type === "internal" && (
              <button
                onClick={buttonClick}
                className="btn btn-warning"
                style={{
                  fontSize: "0.8rem",
                  padding: "6px 10px",
                  height: "40px",
                  lineHeight: "1",
                  whiteSpace: "nowrap",
                }}
              >
                <i className="bi bi-box-arrow-up-right me-1"></i>
                {product?.show_Button_Name || "Visit"}
              </button>
            )}
          </div>
        </div>
      </Toast.Header>
    </Toast>








  )
}

export default ToastProduct